import {
  PublishedBrandingManifest,
  type PublishedBrandingManifest as PublishedBrandingManifestType,
} from "@ascleo/frontdesk-contracts/branding/public";
import { Schema } from "effect";
import type { ActiveBrandingSnapshot } from "./branding-types";

/**
 * Compiled FrontDesk+ default publication used for cold and invalid-cache startup.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * import { DEFAULT_BRANDING_MANIFEST } from "@ascleo/frontdesk-shared/branding";
 *
 * DEFAULT_BRANDING_MANIFEST.publicationVersion; // 0
 * ```
 */
export const DEFAULT_BRANDING_MANIFEST: PublishedBrandingManifestType =
  Schema.decodeUnknownSync(PublishedBrandingManifest)({
    schemaVersion: 1,
    catalogVersion: 1,
    publicationVersion: 0,
    fingerprint: "0".repeat(64),
    publishedAt: "1970-01-01T00:00:00.000Z",
    content: { kind: "default" },
  });

/**
 * Render-safe compiled identity used when a shell has no published or cached brand.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * DEFAULT_ACTIVE_BRANDING.source; // "default"
 * ```
 */
export const DEFAULT_ACTIVE_BRANDING: ActiveBrandingSnapshot = Object.freeze({
  source: "default",
  manifest: DEFAULT_BRANDING_MANIFEST,
  style: Object.freeze({}),
});
